import cx from 'clsx';
import React, { memo } from 'react';

import { HeaderSlotProps } from '@/components/Header/HeaderSlot';
import styles from '@/components/Header/HeaderSlot.module.scss';
import { HeaderItem } from '@/components/Header/types';
import { ShouldPreventDefaultForClick } from '@/components/LaunchStrategiesProvider/utils';
import { isEqual } from '@/utils/lodash-alternatives';

import { createRel } from './utils';

interface CommandItemProps {
  item: HeaderItem;
  onCommandItemClick: HeaderSlotProps['onNavigationCommandClick'];
}

const CommandItem: React.FC<CommandItemProps> = memo(
  ({ item, onCommandItemClick }) => {
    const preventDefaultForClick = ShouldPreventDefaultForClick();

    const handleCommandItemClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (item.command === 'usabilla') {
        e.preventDefault();
        window.usabilla_live && window.usabilla_live('click');
        return;
      }
      if (preventDefaultForClick) e.preventDefault();
      onCommandItemClick &&
        onCommandItemClick({
          itemTitle: item.title,
          account: item.command,
        });
    };

    return (
      <a /* eslint jsx-a11y/anchor-is-valid: 0 */
        className={cx(
          styles.title,
          item.state === 'active' && styles.titleActive
        )}
        data-testid="header-slot-command"
        rel={createRel(item)}
        onClick={handleCommandItemClick}
      >
        {item.title}
      </a>
    );
  },
  (prevProps: CommandItemProps, nextProps: CommandItemProps) =>
    isEqual(prevProps, nextProps)
);

export default CommandItem;
